import { render, staticRenderFns } from "./AppCampaignBanner.vue?vue&type=template&id=02057946&scoped=true&"
import script from "./AppCampaignBanner.vue?vue&type=script&lang=js&"
export * from "./AppCampaignBanner.vue?vue&type=script&lang=js&"
import style0 from "./AppCampaignBanner.vue?vue&type=style&index=0&id=02057946&prod&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02057946",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppSliceLoader: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppSliceLoader.vue').default})
